module.exports = __webpack_public_path__ + "img/empty-fresh-leaf.55659a15.svg";